module.exports = __webpack_public_path__ + "images/emoji/raising_hand.f5b780dfc3169a49ea2a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/raising_hand.png
// module id = V/IF
// module chunks = 2